export const ARTICLE = {}
